export const ARTICLE = {}
